module.exports = __webpack_public_path__ + "static/img/img4.bfb1f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img4.png
// module id = l+my
// module chunks = 0